import React, { useEffect } from 'react';
import { useCampaings } from "../../../application/campaings/hooks/useCampaings";
import ToolbarComponent from '../../ui/section';
import CampaignView from '../../ui/CampaignView';
import NavigationService from '../../../utils/history';

const CampaingIdPage = (props) => {
    const { view, getById, isLoading } = useCampaings();

    useEffect(() => {
        const id = props.match?.params?.id;
        if (id) {
            getById(id);
        }
    }, [props.match?.params?.id, getById]);
    return (
        <>
            <ToolbarComponent label="Campañas" showBackButton={true} onBackClick={() => props.history.goBack()}>
                <CampaignView campaign={view} />
            </ToolbarComponent>
        </>
    )
}

export default CampaingIdPage;